import { render } from "./Event.vue?vue&type=template&id=071c0324"
const script = {}

import exportComponent from "C:\\Users\\TAT SING\\Desktop\\working area\\TatSingGroup-Web\\ts-group\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__